import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'emi-table-date-format',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table-date-format.component.html',
  styleUrls: ['./table-date-format.component.css']
})
export class TableDateFormatComponent implements OnInit, OnChanges {
  @Input() dateData: any;
  public date: any;
  constructor() { }

  ngOnInit() {

  }

  ngOnChanges() {
    this.date = this.dateData;
  }
}
